/**
 * Primary front-end script.
 *
 * Primary JavaScript file. Any includes or anything imported should
 * be filtered through this file and eventually saved back into the
 * `/dist/js/app.js` file.
 *
 * @package   Classe7
 * @author    Matière Noire <contact@matierenoire.io>
 * @copyright 2018 Matière Noire
 * @license   https://www.gnu.org/licenses/gpl-2.0.html GPL-2.0-or-later
 * @link      https://github.com/matiere-noire/classe7
 */

import ScrollMagic from 'scrollmagic'
import cssVars from 'css-vars-ponyfill'

/**
 * A ponyfill that provides client-side support for CSS custom properties (aka “CSS variables”) in legacy and modern browsers.
 * https://jhildenbiddle.github.io/css-vars-ponyfill/#/
 */
cssVars({})

/**
 * Sticky header
 */

// ScrollMagic controler
const controller = new ScrollMagic.Controller()

document.addEventListener('DOMContentLoaded', () => {
	const wpadminbar = document.getElementById('wpadminbar')
	const offset = 50

	const stickyHeader = document.getElementById('sticky-header')
	if (wpadminbar) {
		const wpAdminBarHeight = wpadminbar.offsetHeight
		stickyHeader.style.top = `${wpAdminBarHeight + offset}px`
	}

	const scene = new ScrollMagic.Scene({ offset: offset }).setPin(stickyHeader)

	// Si l'opacité est trop faible on la remonte quand on scroll les pages
	const opacityHeader = getComputedStyle(document.documentElement).getPropertyValue('--header-opacity')
	if (0.5 > parseFloat(opacityHeader)) {
		scene.setClassToggle(stickyHeader, 'min-opacity')
	}

	scene.addTo(controller)
})

/**
 * Scroll reveal
 */

const revealElements = document.querySelectorAll(
	'.is-style-circle-mask, .is-style-reveal-on-scroll, .wp-block-media-text__media, .classe7-icon-hover, .wp-block-embed, .wp-block-classe7-partenaires .wp-block-image, .wp-block-classe7-titre-chiffres-clefs .wp-block-column, .job-offers__service, .wp-block-classe7-modules .wp-block-column'
)
for (let i = 0; i < revealElements.length; i++) {
	// create a scene for each element
	new ScrollMagic.Scene({
		triggerElement: revealElements[i], // y value not modified, so we can use element as trigger as well
		offset: 50, // start a little later
		triggerHook: 0.8
	})
		.setClassToggle(revealElements[i], 'visible') // add class toggle
		.addTo(controller)
}

/**
 * Open menu connexion (secondary)
 */
const secondaryNavToggleButton = document.getElementById('secondary-nav-toggle')

if (secondaryNavToggleButton) {
	const secondaryMenu = document.querySelector('.app-subheader .menu--secondary')

	secondaryNavToggleButton.addEventListener('click', () => {
		secondaryMenu.classList.toggle('menu--secondary-open')
	})
}

/**
 * Open menu
 */
const primaryNavToggleButton = document.getElementById('primary-nav-toggle')

if (primaryNavToggleButton) {
	const primaryMenu = document.querySelector('.app-header .menu--primary')

	primaryNavToggleButton.addEventListener('click', function() {
		this.classList.toggle('active')
		primaryMenu.classList.toggle('open')
	})
}

const menuItems = document.querySelectorAll('.app-header li.has-children')
Array.prototype.forEach.call(menuItems, function(el, i) {
	let timer

	el.addEventListener('mouseover', function(event) {
		el.classList.add('open')
		clearTimeout(timer)
	})
	el.addEventListener('mouseout', function(event) {
		timer = setTimeout(function(event) {
			el.classList.remove('open')
		}, 500)
	})

	el.querySelector('a.menu__link').addEventListener('click', function(event) {
		event.preventDefault()
		if ('has-children' === this.parentNode.className) {
			this.parentNode.className = 'has-children open'
			this.parentNode.querySelector('a').setAttribute('aria-expanded', 'true')
		} else {
			this.parentNode.className = 'has-children'
			this.parentNode.querySelector('a').setAttribute('aria-expanded', 'false')
		}
	})
})

/**
 * Gestion du hover des actualité
 * @type {NodeListOf<Element>}
 */
const typePost = document.querySelectorAll('.entry--type-post')
if (typePost) {
	Array.prototype.forEach.call(typePost, function(el, i) {
		const link = el.querySelector('.entry__permalink')
		if (link){
			link.addEventListener('mouseenter', function() {
				el.classList.add('hover')
			})
			link.addEventListener('mouseleave', function() {
				el.classList.remove('hover')
			})
		}
	})
}
/**
 * A simple immediately-invoked function expression to kick-start
 * things and encapsulate our code.
 *
 * @since  1.0.0
 * @access public
 * @return void
 */
;(function() {
	// Block accordéons
	const allButton = document.querySelectorAll('.wp-block-classe7-accordion button')

	if (allButton) {
		const closeAllAccordions = () => {
			Array.prototype.slice.call(allButton).forEach(function(accordion) {
				const accContent = document.getElementById(accordion.getAttribute('aria-controls'))
				accContent.setAttribute('hidden', '')
				accordion.setAttribute('aria-expanded', 'false')
			})
		}
		Array.prototype.slice.call(allButton).forEach(function(accordion) {
			accordion.addEventListener('click', function(event) {
				// Check if the current toggle is expanded.
				const isExpanded = 'true' === accordion.getAttribute('aria-expanded')

				const accContent = document.getElementById(accordion.getAttribute('aria-controls'))

				if (!isExpanded) {
					// On ferme tous les accordéons de la page quand on en ouvre un
					closeAllAccordions()
				}

				// Set the expanded state on the triggering element
				accordion.setAttribute('aria-expanded', isExpanded ? 'false' : 'true')

				// Hide the accordion sections, using aria-controls to specify the desired section
				if (isExpanded) {
					accContent.setAttribute('hidden', '')
				} else {
					accContent.removeAttribute('hidden')
				}

				event.preventDefault()
			})
		})
	}

	// Accorédons des modules
	// On commence par cacher tout les contenus si nécéssaire
	const allTabContent = document.querySelectorAll('.wp-block-classe7-module-description')
	const allTabLink = document.querySelectorAll('.wp-block-classe7-modules a')

	const closeAllTab = () => {
		Array.prototype.slice.call(allTabContent).forEach(function(moduleDescription) {
			moduleDescription.setAttribute('hidden', '')
		})
		Array.prototype.slice.call(allTabLink).forEach(function(module) {
			module.setAttribute('aria-expanded', 'false')
			module.parentElement.parentElement.classList.remove('current')
		})
	}

	const initialiseTab = () => {
		closeAllTab()
		const hash = window.location.hash

		let currentTab = allTabContent[0]
		let currentTabLink = allTabLink[0]
		if (hash) {
			const currentTabArray = Array.prototype.filter.call(allTabContent, tabContent => {
				return `#${tabContent.getAttribute('id')}` === hash
			})
			if (0 < currentTabArray.length) {
				currentTab = currentTabArray[0]
			}

			const currentTabLinkArray = Array.prototype.filter.call(allTabLink, tabLink => {
				return tabLink.getAttribute('href') === hash
			})
			if (0 < currentTabLinkArray.length) {
				currentTabLink = currentTabLinkArray[0]
			}
		}

		currentTab.removeAttribute('hidden')
		currentTabLink.setAttribute('aria-expanded', 'true')
		currentTabLink.parentElement.parentElement.classList.add('current')
	}

	if (0 < allTabContent.length) {
		initialiseTab()
	}

	Array.prototype.slice.call(allTabLink).forEach(function(accordion, index) {
		accordion.addEventListener('click', function(event) {
			const accContentId = accordion.getAttribute('href').substr(1)
			const accContent = document.getElementById(accContentId)

			closeAllTab()
			accordion.setAttribute('aria-expanded', 'true')
			accordion.parentElement.parentElement.classList.add('current')
			accContent.removeAttribute('hidden')

			jQuery('html, body').animate(
				{
					scrollTop: accContent.offsetTop
				},
				666
			)
			event.preventDefault()
		})
		accordion.addEventListener('mouseenter', function() {
			accordion.parentElement.parentElement.classList.add('modules-hover')
		})
		accordion.addEventListener('mouseleave', function() {
			accordion.parentElement.parentElement.classList.remove('modules-hover')
		})
	})
})()

// Block slider
jQuery(function($) {
	$('.wp-block-cb-carousel')
		.slick('slickSetOption', 'autoplaySpeed', 7000, true)
		.slick('slickPlay') //, { autoplay: true, autoplaySpeed: 7000 })
})
